import { useLocation } from 'react-router';
import { useEffect } from 'react';
import useStore from '../../../hooks/useStore';
import ContentStore from '../../../stores/ContentStore';
import BaseStore from '../../../stores/base-stores/BaseStore';

const RouteChangeListener = () => {
  const location = useLocation();
  const contentStore: BaseStore | undefined = useStore(ContentStore);

  if (contentStore === undefined) {
    return null;
  }

  const { filterStore } = contentStore.rootStore;

  useEffect(() => {
    const state: any = location.state ?? {};
    const doNotResetFilters: boolean = !!state.doNotResetFilters;

    if (doNotResetFilters) {
      return;
    }

    filterStore.resetFilters();
  }, [location.pathname, location.state]);

  return null;
};

export default RouteChangeListener;
